import { DateTime } from "luxon";

import json from "../../json/salesforceContacts.json";

type SalesforceContact = {
  First_Name__c: string;
  Last_Name__c: string;
  Email__c: string;
  Time_zone: string;
  Status__c: string;
  CreatedDate: string;
  Role_Type__c: string;
};

export default async () => {
  const awaitedJson = JSON.parse(JSON.stringify(json));
  const awaitedJsonTyped = [...awaitedJson] as SalesforceContact[];

  awaitedJsonTyped.map((contact, index) => {
    contact.CreatedDate = DateTime.now()
      .minus({
        months: 5 + index,
      })
      .toString();
  });

  return awaitedJsonTyped;
};
